import { observable, action, makeObservable } from 'mobx';
import { EligibilityRuleFilters } from 'typings/enums';

const ruleCategories: {[key: number]: EligibilityRuleFilters} = {
    1: EligibilityRuleFilters.HireDate,
    2: EligibilityRuleFilters.PayEffectiveDate,
    3: EligibilityRuleFilters.AnniversaryDate,
    4: EligibilityRuleFilters.Department,
    5: EligibilityRuleFilters.WorkLocation
};

export class EligibilityRuleFilter {
    ruleCategoryId: number;
    ruleCategoryName: EligibilityRuleFilters;
    @observable ruleCategoryValue: Nullable<string | string[]>;

    constructor(categoryId: number, categoryValue: Nullable<string | string[]> = null) {
        makeObservable(this);
        this.ruleCategoryId = categoryId;
        this.ruleCategoryName = ruleCategories[categoryId];
        this.ruleCategoryValue = categoryValue;
    }

    @action
    setValue(value: string | string[]): void {
        this.ruleCategoryValue = value;
    }
}